import { render } from "./VerticalServiceCard.vue?vue&type=template&id=2097fb0d"
import script from "./VerticalServiceCard.vue?vue&type=script&lang=js"
export * from "./VerticalServiceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__